// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import VerificationDetailsActionTypes from './verification-details.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	addBusinessVerificationResponse: null,
	fetchBusinessVerifyResponse: null,
	fetchBusinessVerifyList: [],
	updateBusinessVerifyResponse: null,
	deleteBusinessVerifyResponse: null,
};
// BUSINESS VERIFICATION DETAILS REDUCER - START
const businessVerificationDetailsReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD BUSINESS VERIFICATION START *********************** */
		case VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_SUCCESS:
			return { ...state, addBusinessVerificationResponse: action.payload };

		case VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_FAILURE:
			return { ...state, addBusinessVerificationResponse: action.payload };

		case VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_RESPONSE_CHANGED:
			return { ...state, addBusinessVerificationResponse: null };
		/** ***************** ADD BUSINESS VERIFICATION END *********************** */

		/** ***************** UPDATE BUSINESS VERIFICATION START *********************** */
		case VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_SUCCESS:
			return { ...state, updateBusinessVerifyResponse: action.payload };

		case VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_FAILURE:
			return { ...state, updateBusinessVerifyResponse: action.payload };

		case VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_RESPONSE_CHANGED:
			return { ...state, updateBusinessVerifyResponse: null };
		/** ***************** UPDATE BUSINESS VERIFICATION END *********************** */

		/** ***************** FETCH BUSINESS VERIFICATION END *********************** */
		case VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_SUCCESS:
			return {
				...state,
				fetchBusinessVerifyResponse: action.payload,
				fetchBusinessVerifyList: docodeHexResponse(action.payload, 'GetBusinessVerifyKey'),
			};

		case VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_FAILURE:
			return { ...state, fetchBusinessVerifyResponse: action.payload };

		case VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_RESPONSE_CHANGED:
			return { ...state, fetchBusinessVerifyResponse: null };
		/** ***************** FETCH BUSINESS VERIFICATION END *********************** */

		/** ***************** DELETE BUSINESS VERIFICATION START *********************** */
		case VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_SUCCESS:
			return { ...state, deleteBusinessVerifyResponse: action.payload };

		case VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_FAILURE:
			return { ...state, deleteBusinessVerifyResponse: action.payload };

		case VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_RESPONSE_CHANGED:
			return { ...state, deleteBusinessVerifyResponse: null };
		/** ***************** DELETE BUSINESS VERIFICATION END *********************** */

		default:
			return state;
	}
};
// BUSINESS VERIFICATION DETAILS REDUCER -END
export default businessVerificationDetailsReducer;
